import Vue       from 'vue'
import VueRouter from 'vue-router'

import Cases                 from '../components/screens/cases/root-pogs-cases'
import Patient               from '../components/screens/patients/root-pogs-patients'
import PatientProfilePreview from '../components/screens/patients/pogs-patient-preview'
import PersonalInformation   from '../components/screens/patientinformation/pogs-personal-information'
import PersonalCaseInformation from '../components/screens/patientinformation/pogs-case-information'
import CaseForm              from '../components/screens/cases/pogs-form--obstetric-case'
import PogsPatientProfile    from '../../src/components/screens/patientprofile/pogs-patient-profile'

import Submissions      from '../components/screens/submissions/root-pogs-submissions'
import SubmissionCases  from '../components/screens/submissions/views/pogs-submissions__cases'
import SubmissionCensus from '../components/screens/submissions/views/pogs-submissions__census'
import SubmissionCensusPackage   from '../components/screens/submissions/views/pogs-submissions__census--package'

import Reports       from '../components/screens/reports/root-pogs-reports'
import ReportSummary from '../components/screens/reports/views/pogs-reports__summary'
import ReportTable   from '../components/screens/reports/views/pogs-reports__table'

import Admin from '../components/screens/admin/root-pogs-admin'
import Users from '../components/screens/admin/pogs-users'
import Roles from '../components/screens/admin/pogs-roles'

import UserForm from '../components/screens/admin/pogs-form--user'
import RoleForm from '../components/screens/admin/pogs-form--role'
import Login    from '../components/screens/login/pogs-login'

import Routes, {ROUTE_OPEN_CENSUS_PACKAGE} from './route-constants'

import Store from '../../src/store/store'
import {
  ACTION_VERIFY_TOKEN,
  GETTER_AUTHENTICATED_USER
} from '../../src/store/modules/accounts'

import {MUTATE_SHOW_OVERLAY} from '../../src/store/modules/shared'

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: {
        name: Routes.ROOT_ROUTE_CASES
      }
    },
    {
      path: '/account/login',
      name: Routes.ROOT_ROUTE_LOGIN,
      component: Login
    },
    {
      path: '/patients',
      name: Routes.ROOT_ROUTE_PATIENTS,
      component: Patient,
      children: [
        {
          path: ':patientid',
          name: Routes.ROUTE_PATIENT_PROFILE_PREVIEW,
          components : {
            patientProfilePreview: PatientProfilePreview
          }
        }
      ]
    },
    {
      path: '/cases',
      name: Routes.ROOT_ROUTE_CASES,
      component: Cases
    },
    {
      path: '/submissions',
      name: Routes.ROOT_ROUTE_SUBMISSIONS,
      component: Submissions,
      children:[
        {
          path: '/submissions/cases', //:casetype',
          name: Routes.ROUTE_SUBMISSION_CASES,
          component: SubmissionCases
        },
        {
          path: '/submissions/census',
          name: Routes.ROUTE_SUBMISSION_CENSUS,
          component: SubmissionCensus
        }
      ]
    },
    {
      path: '/submissions/census/package/:submissionid',
      name: Routes.ROUTE_OPEN_CENSUS_PACKAGE,
      components: {
        overlay: SubmissionCensusPackage
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/reports',
      name: Routes.ROOT_ROUTE_REPORTS,
      component: Reports,
      children: [
        {
          path: '/reports/:filterBy/summary/',
          name: Routes.ROUTE_REPORT_SUMMARY,
          component: ReportSummary
        },
        {
          path: '/reports/:filterBy/table',
          name: Routes.ROUTE_REPORT_TABLE,
          component: ReportTable
        }
      ]
    },
    {
      path: '/patients/:patientid/profile/',
      name: Routes.ROUTE_PATIENT_PROFILE,
      components: {
        overlay: PogsPatientProfile
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/patients/:patientid/newcase',
      name: Routes.ROUTE_NEW_PATIENT_CASE,
      components: {
        overlay: CaseForm
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/patients/:patientid/case/:caseid',
      name: Routes.ROUTE_EDIT_PATIENT_CASE,
      components: {
        overlay: CaseForm
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/newpatient',
      name: Routes.ROUTE_NEW_PATIENT,
      components: {
        overlay: PersonalInformation
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/newpatientcase',
      name: Routes.ROUTE_NEW_PATIENT_CASE_INFO,
      components: {
        overlay: PersonalCaseInformation
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/patients/:patientid/edit',
      name: Routes.ROUTE_EDIT_PATIENT,
      components: {
        overlay: PersonalInformation
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '/patients/:patientid/personalinformation',
      name: Routes.ROUTE_PATIENT_INFO,
      components: {
        overlay: PersonalInformation
      },
      meta: {
        overlay: true
      }
    },
    {
      path: '*',
      redirect: {
        name: Routes.ROOT_ROUTE_CASES
      }
    }
  ],
  mode: 'hash'
});


router.beforeEach((to, from, next) => {

  if(to.name === Routes.ROOT_ROUTE_LOGIN && !localStorage.getItem('pogs-user-token')){
    next();
  }else if(to.name !== Routes.ROOT_ROUTE_LOGIN && !localStorage.getItem('pogs-user-token')){
    next({name: Routes.ROOT_ROUTE_LOGIN});
  }else{
    const toOverlay = to.meta && to.meta.overlay;
    const fromOverlay = from && from.meta && from.meta.overlay;
    if(!fromOverlay && toOverlay) {
      Store.commit(MUTATE_SHOW_OVERLAY, true);
    } else if(fromOverlay && !toOverlay) {
      Store.commit(MUTATE_SHOW_OVERLAY, false)
    }
    Store.dispatch(ACTION_VERIFY_TOKEN, {})
      .then(() => {
        const currentUser = Store.getters[GETTER_AUTHENTICATED_USER];
        if(currentUser._id) {
          if(to.name === Routes.ROOT_ROUTE_LOGIN) {
            next({name: Routes.ROOT_ROUTE_PATIENTS});
          }
          next();
        }else{
          next({name: Routes.ROOT_ROUTE_LOGIN});
        }
      })
      .catch((err)=>{
        if(err.request.status === 504){
          console.log('Waiting for connection...')
        }
        if(err.request.status === 401){
          console.log('session expired, please login again');
          localStorage.removeItem('pogs-user-token');
          next({name: Routes.ROOT_ROUTE_LOGIN});
        }
      })
  }
});

export default router;

